
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[handle]",
      function () {
        return require("private-next-pages/brands/[handle].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[handle]"])
      });
    }
  